import React from 'react';
import {injectIntl} from 'react-intl';
import {Icon} from '@xsolla/uikit';
import PropTypes from 'prop-types';
import styles from './FlashMessage.module.css';

const FlashMessage = ({intl, type, text, onClose}) => (
  <div className={`${styles.flashMessage} ${styles[`flashMessage--${type}`]}`}>
    <span className={styles.flashMessageIcon}>
      <Icon name={type === 'success' ? 'check-circle' : 'alert'} size={24} />
    </span>
    <span style={{flex: 1}}>{text}</span>
    <button
      className={styles.flashMessageClose}
      onClick={onClose}
      type="button"
      aria-label={intl.messages['app.support.disputes.flash-message.close']}>
      <Icon name="close" size={20} />
    </button>
  </div>
);

FlashMessage.propTypes = {
  intl: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default injectIntl(FlashMessage);
